var BxfBadgeSizeEnum;
(function (BxfBadgeSizeEnum) {
    BxfBadgeSizeEnum["PINPOINT"] = "pinpoint";
    BxfBadgeSizeEnum["SMALL"] = "small";
    BxfBadgeSizeEnum["LARGE"] = "large";
})(BxfBadgeSizeEnum || (BxfBadgeSizeEnum = {}));

export { BxfBadgeSizeEnum as B };
